import { render, staticRenderFns } from "./transportation_form.vue?vue&type=template&id=77484d64"
import script from "./transportation_form.vue?vue&type=script&lang=js"
export * from "./transportation_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports